import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function ResetPasswordPage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Les deux mots de passe ne correspondent pas.");
    setError(""); setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe modifié, vous pouvez vous connecter");
      navigate("/login");
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md bg-card border border-border border-t-4 border-t-brand-500 rounded-md p-8 fade-up" data-testid="reset-card">
        <img src="/jn-logo.png" alt="JN Expertise" className="h-12 w-auto object-contain mb-4" />
        <h1 className="font-heading text-2xl font-bold text-foreground">Nouveau mot de passe</h1>
        <p className="text-sm text-muted-foreground mt-1">Choisissez un mot de passe d'au moins 6 caractères.</p>
        {!token ? (
          <div className="mt-5 text-sm text-red-600 dark:text-red-400" data-testid="reset-missing-token">Lien invalide : aucun jeton fourni. <Link to="/login" className="underline">Retour à la connexion</Link></div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div><Label htmlFor="pwd">Mot de passe</Label><Input id="pwd" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></div>
            <div><Label htmlFor="pwd2">Confirmation</Label><Input id="pwd2" type="password" minLength={6} required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" /></div>
            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-200 dark:text-red-400 dark:bg-red-500/10 dark:border-red-500/40 rounded-md px-3 py-2" data-testid="reset-error">{error}</div>}
            <Button type="submit" className="w-full" disabled={busy} data-testid="reset-submit-button">{busy ? "Enregistrement…" : "Enregistrer le mot de passe"}</Button>
            <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-brand-600" data-testid="reset-back-link">Retour à la connexion</Link>
          </form>
        )}
      </div>
    </div>
  );
}
